export enum ImageLoaderSize {
  small,
  medium,
  large,
}

export const enum WearableType {
  Top = "Top",
  Bottom = "Bottom",
  Dress = "Dress",
}

export const enum Gender {
  Male = "Male",
  Female = "Female",
}

export const enum SnackbarType {
  success = "Success",
  error = "Error",
}

export const enum DialogType {
  success = "Success",
  error = "Error",
  info = "Info",
  action = "Action",
  alert = "Alert",
}
